import React from "react";
import { message } from "antd";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { EntityStatus, NavMenuItems } from "../../Constants/Constants";
import { apiCallback, statusChangeApiCallback } from "../../ApiHandlers/Common";
import ListServiceTier from "./ListServiceTier";
import ServiceTierForm from "./ServiceTierForm";
import PropTypes from "prop-types";
import MainPage from "../MainPage";
import { convertServiceTierList } from "../../Helpers/ServiceTierHelpers";

class ServiceTier extends React.Component {
  constructor(props) {
    super(props);
    this.header = [
      ...(props.parentBread || []),
      <>
        {NavMenuItems.serviceTier.icon()}
        <span>{NavMenuItems.serviceTier.label}</span>
      </>,
    ];
    this.state = {
      action: null,
      record: null,
      serviceTierData: [],
      serviceTierDataLoading: false,
    };
    console.log("ServiceTier props", props);
  }

  componentDidMount() {
    this.updateServiceTierList();
  }

  updateServiceTierList() {
    console.log("updateDataList...");
    const { history, deviceModelRecord, serviceTierApi } = this.props;
    this.setState({ serviceTierDataLoading: true });
    const errorCallback = () => {
      this.setState({ serviceTierDataLoading: false });
      message.error("Error fetching Service Tier list");
    };
    const successCallback = (data) => {
      const serviceTierData = convertServiceTierList(data);
      console.log("updateDataList data", serviceTierData);
      this.setState({ serviceTierData, serviceTierDataLoading: false });
    };
    try {
      if (deviceModelRecord) {
        serviceTierApi.getServiceTierByDeviceModel(
          deviceModelRecord.modelId,
          apiCallback({ history, errorCallback, successCallback })
        );
      } else {
        serviceTierApi.getAllServiceTiers(
          apiCallback({ history, errorCallback, successCallback })
        );
      }
    } catch (error) {
      errorCallback();
    }
  }

  onActionClick = (action, record) => (e) => {
    this.setState({ action, record });
  };

  onSubmit = ({ update = true, redirect = true } = {}) => {
    update && this.updateServiceTierList();
    redirect && this.setState({ action: null, record: null });
  };

  onStatusChange = (record, status) => {
    try {
      console.log("onStatusChange", status, record);
      const { serviceTierId, offerId, deviceModelId } = record;
      const callback = statusChangeApiCallback({
        props: this.props,
        recordName: record.serviceTierName,
        errorRollback: () =>
          this.changeStatus(serviceTierId, offerId, deviceModelId, !status),
      });
      if (status) {
        this.props.serviceTierApi.activateServiceTier(
          serviceTierId,
          offerId,
          deviceModelId,
          callback
        );
      } else {
        this.props.serviceTierApi.inactivateServiceTier(
          serviceTierId,
          offerId,
          deviceModelId,
          callback
        );
      }
      this.changeStatus(serviceTierId, offerId, deviceModelId, status);
    } catch (error) {
      message.error(`Error changing status of ${record.serviceTierName}`);
    }
  };

  changeStatus = (serviceTierId, offerId, deviceModelId, status) => {
    const serviceTierData = [...this.state.serviceTierData];
    serviceTierData.forEach((item) => {
      if (item.serviceTierId === serviceTierId) {
        const offeringData = [...(item?.offeringData?.data || [])];
        offeringData?.forEach((offer) => {
          if (
            offer.offerId === offerId &&
            offer.deviceModelId === deviceModelId
          ) {
            offer.status = status ? EntityStatus.ACTIVE : EntityStatus.INACTIVE;
            return;
          }
        });
        item.offeringData.data = offeringData;
      }
    });
    this.setState({ serviceTierData });
  };

  render() {
    const { deviceModelRecord, onParentActionClick } = this.props;
    const { action, record, serviceTierData, serviceTierDataLoading } =
      this.state;
    const serviceTierPage = (
      <div className="service-tier-container">
        {!action ? (
          <ListServiceTier
            deviceModelRecord={deviceModelRecord}
            serviceTierDataLoading={serviceTierDataLoading}
            serviceTierData={serviceTierData}
            onActionClick={this.onActionClick}
            onParentActionClick={onParentActionClick}
            onStatusChange={this.onStatusChange}
            parentBread={this.header}
          />
        ) : (
          <ServiceTierForm
            action={action}
            record={record}
            deviceModelRecord={deviceModelRecord}
            onSubmit={this.onSubmit}
            onActionClick={this.onActionClick}
            parentBread={this.header}
          />
        )}
      </div>
    );
    return deviceModelRecord ? (
      serviceTierPage
    ) : (
      <MainPage>{serviceTierPage}</MainPage>
    );
  }
}

ServiceTier.propTypes = {
  deviceModelRecord: PropTypes.object,
  onParentActionClick: PropTypes.func,
  serviceTierApi: PropTypes.object,
};

const mapStateToProps = (state) => ({
  serviceTierApi: state.apis.serviceTierApi,
});
const connectedServiceTier = connect(mapStateToProps)(ServiceTier);
export default withRouter(connectedServiceTier);
